import styled from 'styled-components'

export const GeneratorBarContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-end;
  border-radius: 5px;

  box-shadow: 0 24px 36px rgba(0, 0, 0, 0.11),
    0 24px 46px var(--display-bar-shadow);
`
